import React, { useRef, useEffect } from 'react';
import { useLoader } from '@react-three/fiber';
import * as THREE from 'three';

const PictureMesh = ({ url, position }) => {
    const texture = useLoader(THREE.TextureLoader, url);
    const meshRef = useRef();

    useEffect(() => {
        if (meshRef.current) {
            const { width, height } = texture.image;
            meshRef.current.scale.set(width / 90, height / 90, 1);
        }
    }, [texture]);

    // -1.5708
    return (
        <mesh ref={meshRef} position={position} rotation={[-1.5708, 0, 0]}>
            <planeGeometry attach="geometry" args={[1, 1]} />
            <meshBasicMaterial attach="material" map={texture} />
        </mesh>
    );
};

export default PictureMesh;
